const basePath = `https://blog.${process.env.robloxSiteDomain}`;
// eslint-disable-next-line import/prefer-default-export
export const getUrl = () => basePath;
